import type {KeyboardSensorOptions} from '@dnd-kit/core'

/**
 * Metadata that will be attached to the draggable element.
 */
export type DragDropMetadata<T> = {id: T}

export type keyboardAndSRSensorOption = Omit<KeyboardSensorOptions, 'onActivation'> & {
  onActivation?({event, returnFocusRef}: {event: KeyboardEvent; returnFocusRef: React.RefObject<HTMLElement>}): void
}

/**
 * Arguments passed to the onDrop callback.
 * @param dragMetadata - Metadata of the dragged item
 * @param dropMetadata - Metadata of the item that was dropped on
 * @param isBefore - is the dragItem before the drop target
 */
export interface OnDropArgs<T> {
  dragMetadata: DragDropMetadata<T>
  dropMetadata: DragDropMetadata<T>
  isBefore: boolean
}

export type DragAndDropDirection = 'horizontal' | 'vertical'

export enum DragAndDropMoveOptions {
  BEFORE = 'Move item before',
  AFTER = 'Move item after',
  ROW = 'Move to row',
}

export type DragAndDropItem = {
  id: string | number
  title: string
}
